/**
 * 创建人：zll
 * 时间：2022-5-07
 * 描述：选择日期组件(Ant Design日期组件)
 * 使用说明: 参考 sw-nz-date 配置应用说明文档 
 * 更新记录: 
 */
import { Component, OnInit, Input, forwardRef, Output, EventEmitter, HostListener, ElementRef, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { format, differenceInCalendarDays } from 'date-fns';
import { setHours } from 'date-fns'
import { JSONPBackend } from '@angular/http';
declare var $: any;

export const EXE_COUNTER_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SwNzDateComponent),
  multi: true
};
/**
 * 日期控件 sw-nz-date
 * 日期类组件包括以下五种形式。
 * nz-date-picker
 * nz-month-picker
 * nz-range-picker
 * nz-week-picker
 * nz-year-picker ==>year比较特殊，有部分共享的api
 * nz-time-picker ==》时分秒
 * 注意： 所有输入输出日期对象均为 Date，你可以通过 date-fns 工具库获得你需要的数据。
 */
@Component({
  selector: 'sw-nz-date',
  providers: [EXE_COUNTER_VALUE_ACCESSOR],
  templateUrl: './sw-nz-date.component.html',
  styleUrls: ['./sw-nz-date.component.css']
})
export class SwNzDateComponent implements OnInit {
  date2: any

  date: any; // new Date();==>Fri May 13 2022 09:56:55 GMT+0800 (中国标准时间)    ==>单面板
  dateRange: any = []; // [Mon Jun 20 2022 11:01:10 GMT+0800 (中国标准时间), Wed Jun 22 2022 11:01:10 GMT+0800 (中国标准时间)]  ==>双面板
  timeData: any;//Date | null = null

  //日期类组件形式类型五种：date、month、year、range、time
  @Input() type: string = "date"

  //以下 API 为 nz-date-picker、nz-month-picker、nz-range-picker,nz-year-picker(有部分) 共享的 API
  //是否显示清除按钮
  @Input() allowClear: boolean = true
  //自动获取焦点
  @Input() autoFocus: boolean = false

  //先根据 nz-date-picker 的API，封装type类型为 date 的日期组件
  //选择器 className
  @Input() className: string = ""

  //禁用
  @Input() disabled: boolean = false

  //   //不可选择的日期（year-picker不支持）
  //   @Input() disabledDate: any  

  //    //控制弹层是否展开
  //  @Input() open: boolean = true

  //输入框提示文字
  @Input() placeholder: any = ""

  //日期格式 
  @Input() format: string = "yyyy-MM-dd HH:mm:ss"

  //是否显示时间面板  object / boolean   =>[nzShowTime]="{ nzFormat: 'HH:mm' }"
  @Input() showTime: any = true

  //是否展示“今天”按钮
  @Input() showToday: boolean = true

  /**
  * 最小日期 或者 "1900-01-01" 或者 "10:30:25"
  **/
  @Input() minDate: string = "1900-01-01 00:00:00"

  /**
   * 最大日期 或者 "2099-12-31" 或者 "16:35:25"
   */
  @Input() maxDate: string = "2099-12-31 23:59:59"

  //预设时间范围快捷选择   { [ key: string ]: Date[] }   ==》只有双面板有  range
  @Input() ranges: any
  //小时选项间隔  只有类型为 time有此项
  @Input() hourStep: any = '1'
  //分钟选项间隔  只有类型为 time有此项
  @Input() minuteStep: any = '1'
  //秒选项间隔  只有类型为 time有此项
  @Input() secondStep: any = '1'
  /**
   * 输入框
   */
  @ViewChild('input') input: ElementRef;
  /**
  * 选中事件抛出
  */
  @Output() change = new EventEmitter()

  /**
   * 日期初始化时默认值
   * @ignore  
   */
  _dateinit: any;
  /**
   * @ignore
   */
  constructor(
    private el: ElementRef
  ) {

  }

  //时间发生变化的回调   ===》单面板
  onChange(result: Date): void {
    // console.log('onChange: ', result);
    //根据日期格式，处理数据
    //console.log(this.date)
    this.date = result
    if (result) {
      this.Dateinit = this.dateFormat(result)
    } else {
      this.Dateinit = null
    }
    this.change.emit(this.Dateinit)
  }
  //弹出日历和关闭日历的回调  ===》单面板
  onOpenChange($event) {
    // console.log('onOpenChange: ', $event);
    // console.log(this.date)
    //this.Dateinit="Fri May 19 2022 09:56:55 GMT+0800 (中国标准时间)"
  }
  //点击确定按钮的回调  ===》单面板
  onOk($event) {
    // console.log('onOk: ', $event);
    // console.log(this.date)
    // let result = $event
    // //根据日期格式，处理数据
    // this.date = result
    // if(result){
    //   this.Dateinit = this.dateFormat(result)
    // }else {
    //   this.Dateinit = null
    // }
    // this.change.emit(this.Dateinit)
  }
  getWeek(result: Date): void {
    // console.log('week: ', result);
  }

  //ranage    时间发生变化的回调   ===》双面板
  onChange2(result: Date[]): void {
    // console.log('onChange2: ', result);
    //根据日期格式，处理数据
    // console.log(this.dateRange)
    this.dateRange = result
    if (result && result.length > 0) {
      let start = this.dateFormat(result[0])
      let end = this.dateFormat(result[1])
      this.Dateinit = start + '#' + end
    } else {
      this.Dateinit = null
    }
    this.change.emit(this.Dateinit)
  }
  //点击确定按钮的回调  ===》双面板
  onOk2($event) {
    // console.log('onOk2: ', $event);
    // console.log(this.dateRange)
    // let result = $event
    // //根据日期格式，处理数据
    // this.dateRange = result
    // if(result && result.length > 0){
    //    let start = this.dateFormat(result[0])
    //    let end = this.dateFormat(result[1])
    //    this.Dateinit = start + '#' + end
    // }else {
    //   this.Dateinit = null
    // }
    //this.change.emit(this.Dateinit)
  }
  //时间发生变化的回调 ==>time
  onChange3(result: Date): void {

    console.log('onChange3: ', result);
    //根据日期格式，处理数据
    //console.log(this.date)
    this.timeData = result
    if (result) {
      let before = JSON.parse(JSON.stringify(this.Dateinit))
      let dts = this.dateFormat2(result)
      if (before != dts) {
        this.Dateinit = JSON.parse(JSON.stringify(dts))
        this.change.emit(this.Dateinit)
      }
      // this.Dateinit = result
      // this.Dateinit = this.dateFormat2(result)
    } else {
      this.Dateinit = null
      this.change.emit(this.Dateinit)
    }

  }

  // timeDefaultValue:any
  /**
   * @ignore
   */
  ngOnInit() {
    // this.timeDefaultValue = setHours(new Date(),9);
    // console.log(this.timeDefaultValue)
    // var d = new Date();
    //  d.setHours(15, 35, 1);
    //  console.log(d)

  }

  /**
   * @ignore
   */
  ngAfterViewInit(): void {

  }

  ngOnDestroy(): void {

  }


  /**
     * @ignore
     */
  get Dateinit() {
    //  
    return this._dateinit;
  }

  /**
 * @ignore
 */
  set Dateinit(value: any) {

    console.log(this.type, 'opopop')
    console.log(value)
    this._dateinit = value;
    this.propagateChange(this._dateinit);
    //console.log(this.format)
    //根据日期格式，处理数据
    if (value) {
      //range  ==》双面板 
      if (this.type == 'range') {
        let ar1 = []
        let dat1 = value.split('#')
        if (this.format.indexOf("HH") >= 0 && this.format.indexOf("mm") == -1) {
          //处理当格式为yyyy-MM-dd HH时，报错问题 ==》值转为 yyyy-MM-dd HH:ss 
          let vas1 = JSON.parse(JSON.stringify(dat1[0]))
          vas1 = vas1 + ':00'
          let vas2 = JSON.parse(JSON.stringify(dat1[1]))
          vas2 = vas2 + ':00'
          ar1[0] = new Date(vas1)
          ar1[1] = new Date(vas2)
        } else {
          ar1[0] = new Date(dat1[0])
          ar1[1] = new Date(dat1[1])
        }
        this.dateRange = [...ar1]
      } else if (this.type == 'time') {
        //时分秒
        // this.timeData = value
        // this.mathDateTime('11:09:09')
        this.timeData = this.mathDateTime(value)
      } else {
        //==》单面板
        if (this.format.indexOf("HH") >= 0 && this.format.indexOf("mm") == -1) {
          //处理当格式为yyyy-MM-dd HH时，报错问题 ==》值转为 yyyy-MM-dd HH:ss
          let vas = JSON.parse(JSON.stringify(value))
          vas = vas + ':00'
          this.date = new Date(vas) + ''
        } else {
          this.date = new Date(value) + ''
        }
      }


    } else {
      if (this.type == 'range') {
        this.dateRange = []
      } else if (this.type == 'time') {
        this.timeData = null
      } else {
        this.date = null
      }
    }



  }
  mathDateTime(value) {
    //获取当前日期
    let dt = new Date()
    // 处理年份
    let years = dt.getFullYear().toString()
    // 处理月份

    let MM = (dt.getMonth() + 1);
    let months = MM <= 9 ? "0" + MM.toString() : MM.toString()

    // 处理天
    let DD = dt.getDate();
    let days = DD <= 9 ? "0" + DD.toString() : DD.toString()
    let str
    if (this.format.indexOf("ss") >= 0) {
      str = years + '-' + months + '-' + days + ' ' + value

    } else if (this.format.indexOf("mm") >= 0) {
      let ss = dt.getSeconds();
      let sss = ss <= 9 ? "0" + ss.toString() : ss.toString()
      str = years + '-' + months + '-' + days + ' ' + value + ':' + sss
    } else {
      let ss = dt.getSeconds();
      let sss = ss <= 9 ? "0" + ss.toString() : ss.toString()
      let mm = dt.getMinutes();
      let mmm = mm <= 9 ? "0" + mm.toString() : mm.toString()
      str = years + '-' + months + '-' + days + ' ' + value + ':' + mmm + ':' + sss
    }
    // console.log(new Date(str))
    return new Date(str)
  }
  /**
   * @ignore
   */
  propagateChange = (_: any) => {
  };

  /**
   * 该方法用于将模型中的新值写入视图或 DOM 属性中。
   * @ignore
   */
  writeValue(value: any) {
    //
    this.Dateinit = value;
  }

  /**
   * 设置当控件接收到 change 事件后，调用的函数
   * @ignore
   */
  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }
  /**
   * 设置当控件接收到 touched 事件后，调用的函数
   * @ignore
   */
  registerOnTouched(fn: any) { }



  /**
   * 构子
   * @ignore
   */
  ngOnChanges(event): void {


  }


  //将传入的参数日期格式化
  dateFormat(val: Date) {
    let jeDt
    //"yyyy-MM-dd HH:mm:ss"
    let dats = JSON.parse(JSON.stringify(this.format))
    let dt = new Date(val)
    //根据format，处理数据获取Dateinit值
    // console.log(dt)
    // console.log(dt.getDate())
    // console.log(dt.getFullYear())
    // 处理年份
    if (this.format.indexOf("yyyy") >= 0) {
      dats = dats.replace("yyyy", dt.getFullYear().toString())
    }
    // 处理月份
    if (this.format.indexOf("MM") >= 0) {
      let MM = (dt.getMonth() + 1);
      // 补零操作
      if (MM <= 9)
        dats = dats.replace("MM", "0" + MM.toString())
      else
        dats = dats.replace("MM", MM.toString())
    }
    // 处理天
    if (this.format.indexOf("dd") >= 0) {
      let DD = dt.getDate();
      // 补零操作
      if (DD <= 9)
        dats = dats.replace("dd", "0" + DD.toString())
      else
        dats = dats.replace("dd", DD.toString())
    }
    // 处理小时
    if (this.format.indexOf("HH") >= 0) {
      let hh = dt.getHours();
      // 补零操作
      if (hh <= 9)
        dats = dats.replace("HH", "0" + hh.toString())
      else
        dats = dats.replace("HH", hh.toString())
    }
    // 处理分钟
    if (this.format.indexOf("mm") >= 0) {
      let mm = dt.getMinutes();
      // 补零操作
      if (mm <= 9)
        dats = dats.replace("mm", "0" + mm.toString())
      else
        dats = dats.replace("mm", mm.toString())
    }
    // 处理秒钟
    if (this.format.indexOf("ss") >= 0) {
      let ss = dt.getSeconds();
      // 补零操作
      if (ss <= 9)
        dats = dats.replace("ss", "0" + ss.toString())
      else
        dats = dats.replace("ss", ss.toString())
    }

    return dats
  }

  dateFormat2(val: Date) {
    //"HH:mm:ss"
    let dats = JSON.parse(JSON.stringify(this.format))
    let dt = new Date(val)
    // 处理小时
    if (this.format.indexOf("HH") >= 0) {
      let hh = dt.getHours();
      // 补零操作
      if (hh <= 9)
        dats = dats.replace("HH", "0" + hh.toString())
      else
        dats = dats.replace("HH", hh.toString())
    }
    // 处理分钟
    if (this.format.indexOf("mm") >= 0) {
      let mm = dt.getMinutes();
      // 补零操作
      if (mm <= 9)
        dats = dats.replace("mm", "0" + mm.toString())
      else
        dats = dats.replace("mm", mm.toString())
    }
    // 处理秒钟
    if (this.format.indexOf("ss") >= 0) {
      let ss = dt.getSeconds();
      // 补零操作
      if (ss <= 9)
        dats = dats.replace("ss", "0" + ss.toString())
      else
        dats = dats.replace("ss", ss.toString())
    }
    return dats
  }
  //nz-date-picker组件 日期禁用功能
  //禁用日期功能
  // today = new Date();
  @Input() disabledDate = (current: Date): boolean => {
    let mindate = new Date(this.minDate)
    let maxdate = new Date(this.maxDate)
    return differenceInCalendarDays(current, mindate) < 0 || differenceInCalendarDays(current, maxdate) > 0;
  };

  //时间禁用功能
  range(start: number, end: number): number[] {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    //console.log(result)
    return result;
  }
  //nz-date-picker组件 时间禁用功能
  @Input() disabledDateTime = (): object => {
    // if(this.format.indexOf("HH") >= 0 && this.format.indexOf("mm") >= 0 && this.format.indexOf("ss") >= 0){
    //   return {
    //     nzDisabledHours  : () => [],
    //     nzDisabledMinutes: () => [],
    //     nzDisabledSeconds: () => []
    //   };
    // }else if(this.format.indexOf("HH") >= 0 && this.format.indexOf("mm") >= 0 && this.format.indexOf("ss") == -1){
    //   return {
    //     nzDisabledHours  : () => [],
    //     nzDisabledMinutes: () => [],
    //     nzDisabledSeconds: () => this.range(0, 60)
    //   };

    // }else if(this.format.indexOf("HH") >= 0 && this.format.indexOf("mm") == -1 && this.format.indexOf("ss") == -1){
    //   return {
    //     nzDisabledHours  : () => [],
    //     nzDisabledMinutes: () => this.range(0, 60),
    //     nzDisabledSeconds: () => this.range(0, 60)
    //   };
    // }else {
    //   return {
    //     nzDisabledHours  : () => [],
    //     nzDisabledMinutes: () => [],
    //     nzDisabledSeconds: () => []
    //   };
    // }
    return {
      nzDisabledHours: () => [],
      nzDisabledMinutes: () => [],
      nzDisabledSeconds: () => []
    };
  };



  //nz-range-picker 时间禁用功能
  @Input() disabledRangeTime = (value: Date[], type: 'start' | 'end'): object => {
    if (type === 'start') {
      return {
        // nzDisabledHours  : () => this.range(0, 60).splice(4, 20),
        // nzDisabledMinutes: () => this.range(30, 60),
        // nzDisabledSeconds: () => [ 55, 56 ]
        nzDisabledHours: () => [],
        nzDisabledMinutes: () => [],
        nzDisabledSeconds: () => []
      };
    }
    return {
      // nzDisabledHours  : () => this.range(0, 60).splice(20, 4),
      // nzDisabledMinutes: () => this.range(0, 31),
      // nzDisabledSeconds: () => [ 55, 56 ]
      nzDisabledHours: () => [],
      nzDisabledMinutes: () => [],
      nzDisabledSeconds: () => []
    };
  };
  //nz-time-picker 时间部分禁用功能
  //禁用小时
  @Input() disabledHours = (): number[] => {
    return [];
  }
  //禁用分钟
  @Input() disabledMinutes = (hour: number): number[] => {
    return [];
  }
  //禁用秒
  @Input() disabledSeconds(hour: number, minute: number): number[] {
    return [];
  }
}